module.exports = __webpack_public_path__ + "static/media/in_a_week_sample_4.34899f8c.jpg";